import { useState, useEffect } from "react";
import useTranslation from "next-translate/useTranslation";
import useGoogle from "react-google-autocomplete/lib/usePlacesAutocompleteService";

const AutocompletePoints = ({ setStart, setEnd, router }) => {
  const { placePredictions, getPlacePredictions, isPlacePredictionsLoading } =
    useGoogle({
      apiKey: "AIzaSyBlIxtZS1x0M33lgI1kt65c95TJWbtrZsM",
      debounce: 800,
      options: { region: "bg" },
    });

  const { t } = useTranslation("book");

  const [startValue, setStartValue] = useState("");
  const [endValue, setEndValue] = useState("");

  const [startToggle, setStartToggle] = useState(false);
  const [endToggle, setEndToggle] = useState(false);

  // When value is changed emit to the parent
  useEffect(() => {
    setStart(startValue);
    setEnd(endValue);
  }, [startValue, endValue, setStart, setEnd]);

  // When value is changed emit to the parent
  useEffect(() => {
    if (router.isReady) {
      const { origin, destination } = router.query;
      setStartValue(origin);
      setEndValue(destination);
    }
  }, [router.isReady, router.query]);

  // Will swap start and end locations
  const swapLocations = () => {
    const temp = startValue;
    setStartValue(endValue);
    setEndValue(temp);
  };

  return (
    <div className="flex flex-row mb-2">
      <div className="flex flex-col gap-1 w-4/5 relative">
        <div className="flex items-center">
          <svg
            width={25}
            height={25}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            className="absolute ml-[5px] text-accent"
          >
            <path
              fillRule="evenodd"
              d="M11.54 22.351l.07.04.028.016a.76.76 0 00.723 0l.028-.015.071-.041a16.975 16.975 0 001.144-.742 19.58 19.58 0 002.683-2.282c1.944-1.99 3.963-4.98 3.963-8.827a8.25 8.25 0 00-16.5 0c0 3.846 2.02 6.837 3.963 8.827a19.58 19.58 0 002.682 2.282 16.975 16.975 0 001.145.742zM12 13.5a3 3 0 100-6 3 3 0 000 6z"
              clipRule="evenodd"
            />
          </svg>
          <input
            autoComplete="off"
            id="start"
            className="pl-[35px] bg-jacarta-100  dark:bg-jacarta-700 hover:ring-accent/10 focus:ring-accent dark:border-jacarta-600 dark:placeholder:text-jacarta-300 w-full rounded-lg py-3 hover:ring-2 dark:text-white"
            required
            name="start"
            value={startValue || ""}
            onFocus={() => {
              setEndToggle(false);
            }}
            onChange={(event) => {
              setStartValue(event.target.value);
              getPlacePredictions({
                input: event.target.value,
              });
              setStartToggle(true);
            }}
            placeholder={t("pick-up")}
          ></input>
        </div>
        <div className="flex w-full flex-col">
          {!isPlacePredictionsLoading && startToggle && (
            <div className="absolute top-[50px] z-50 rounded-md w-full bg-jacarta-100  dark:bg-jacarta-700 p-1">
              <ul className="w-full overflow-hidden overflow-y-auto max-h-[190px] dark:text-jacarta-100  outline-none appearance-none cursor-pointer">
                {placePredictions.map((item) => (
                  <li
                    className="flex items-center text-base p-2 cursor-pointer"
                    key={item.place_id}
                    onClick={() => {
                      setStartValue(item?.description);
                      setStartToggle(false);
                    }}
                  >
                    <svg
                      width={22}
                      height={22}
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="red"
                      className="mr-1 shrink-0"
                    >
                      <path
                        fillRule="evenodd"
                        d="M11.54 22.351l.07.04.028.016a.76.76 0 00.723 0l.028-.015.071-.041a16.975 16.975 0 001.144-.742 19.58 19.58 0 002.683-2.282c1.944-1.99 3.963-4.98 3.963-8.827a8.25 8.25 0 00-16.5 0c0 3.846 2.02 6.837 3.963 8.827a19.58 19.58 0 002.682 2.282 16.975 16.975 0 001.145.742zM12 13.5a3 3 0 100-6 3 3 0 000 6z"
                        clipRule="evenodd"
                      />
                    </svg>
                    {item?.description}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
        <div className="flex items-center relative">
          <svg
            width={25}
            height={25}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            className="absolute ml-[5px] text-accent"
          >
            <path
              fillRule="evenodd"
              d="M11.54 22.351l.07.04.028.016a.76.76 0 00.723 0l.028-.015.071-.041a16.975 16.975 0 001.144-.742 19.58 19.58 0 002.683-2.282c1.944-1.99 3.963-4.98 3.963-8.827a8.25 8.25 0 00-16.5 0c0 3.846 2.02 6.837 3.963 8.827a19.58 19.58 0 002.682 2.282 16.975 16.975 0 001.145.742zM12 13.5a3 3 0 100-6 3 3 0 000 6z"
              clipRule="evenodd"
            />
          </svg>
          <input
            autoComplete="off"
            id="end"
            className="pl-[35px] bg-jacarta-100  dark:bg-jacarta-700 hover:ring-accent/10 focus:ring-accent dark:border-jacarta-600 dark:placeholder:text-jacarta-300 w-full rounded-lg py-3 hover:ring-2 dark:text-white"
            required
            name="end"
            value={endValue || ""}
            onFocus={() => {
              setStartToggle(false);
            }}
            onChange={(event) => {
              setEndValue(event.target.value);
              getPlacePredictions({ input: event.target.value });
              setEndToggle(true);
            }}
            placeholder={t("drop-off")}
          ></input>
        </div>
        <div className="flex w-full flex-col">
          {!isPlacePredictionsLoading && endToggle && (
            <div className="absolute z-50 rounded-md bg-jacarta-100 w-full dark:bg-jacarta-700 p-1">
              <ul className="w-full overflow-hidden overflow-y-auto max-h-[190px] dark:text-jacarta-100  outline-none appearance-none cursor-pointer">
                {placePredictions.map((item) => (
                  <li
                    className="flex text-base items-center cursor-pointer p-2"
                    key={item.place_id}
                    onClick={() => {
                      setEndValue(item?.description);
                      setEndToggle(false);
                    }}
                  >
                    <svg
                      width={22}
                      height={22}
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="red"
                      className="mr-1 shrink-0"
                    >
                      <path
                        fillRule="evenodd"
                        d="M11.54 22.351l.07.04.028.016a.76.76 0 00.723 0l.028-.015.071-.041a16.975 16.975 0 001.144-.742 19.58 19.58 0 002.683-2.282c1.944-1.99 3.963-4.98 3.963-8.827a8.25 8.25 0 00-16.5 0c0 3.846 2.02 6.837 3.963 8.827a19.58 19.58 0 002.682 2.282 16.975 16.975 0 001.145.742zM12 13.5a3 3 0 100-6 3 3 0 000 6z"
                        clipRule="evenodd"
                      />
                    </svg>
                    {item?.description}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </div>
      <div
        className="flex flex-col justify-center items-center cursor-pointer w-1/5 bg-jacarta-100 dark:bg-jacarta-700 rounded-lg ml-1 border-b-4 border-accent"
        onClick={() => swapLocations()}
      >
        <svg
          width={25}
          height={25}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          className="dark:text-white"
        >
          <path
            fillRule="evenodd"
            d="M6.97 2.47a.75.75 0 011.06 0l4.5 4.5a.75.75 0 01-1.06 1.06L8.25 4.81V16.5a.75.75 0 01-1.5 0V4.81L3.53 8.03a.75.75 0 01-1.06-1.06l4.5-4.5zm9.53 4.28a.75.75 0 01.75.75v11.69l3.22-3.22a.75.75 0 111.06 1.06l-4.5 4.5a.75.75 0 01-1.06 0l-4.5-4.5a.75.75 0 111.06-1.06l3.22 3.22V7.5a.75.75 0 01.75-.75z"
            clipRule="evenodd"
          />
        </svg>
        <span className="dark:text-white text-sm">{t("swap")}</span>
      </div>
    </div>
  );
};

export default AutocompletePoints;
